// Paleta compartilhada entre ColorPicker e NewStageSheet.
export const SWATCHES = [
  "#94a3b8", // slate
  "#64748b",
  "#0ea5e9", // sky
  "#3b82f6", // blue
  "#8b5cf6", // violet
  "#a78bfa",
  "#ec4899", // pink
  "#f97316", // orange
  "#f59e0b", // amber
  "#eab308", // yellow
  "#22c55e", // green
  "#10b981",
  "#14b8a6", // teal
  "#ef4444", // red
  "#dc2626",
];
